// extracted by mini-css-extract-plugin
export default {"AddonIconsCard":"AddonIcons_AddonIconsCard__QQTgN","iconBox":"AddonIcons_iconBox__swzPh","icon":"AddonIcons_icon__LPt7J"};